module.exports = __webpack_public_path__ + "img/BaiQi.8571f9e4.png";